import AdminEleven from "@/layouts/AdminEleven.vue";

export const peopleRoutes = [
  {
    path: "",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "users",
        path: "/pessoas/usuarios",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/people/Users.vue"),
        meta: {
          title: "Pessoas/Usuários",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "userSettings",
        path: "pessoas/usuarios/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/people/UsersSettings.vue"
          ),
        meta: {
          title: "Pessoas/Usuários - cadastrar",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "affiliates",
        path: "/affiliates",
        component: () => import("@/views/people/Affiliates.vue"),
        meta: {
          title: "Afiliados",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];

export const redefinePassRoutes = [
  {
    path: "/usuario-admin-redefinir-senha",
    name: "redefineAdminPass",
    props: true,
    params: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/people/RedefinePass"),
    meta: {
      title: "Redefinir Senha",
      requiresAuth: true,
      requiresAdminProfile: true,
    },
  },
  {
    path: "/recuperar-senha-admin",
    name: "recoveryAdminPass",
    props: true,
    params: true,
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/people/RecoveryAdminPass.vue"
      ),
    meta: { title: "Recuperar senha", requiresAuth: false },
  },
  {
    path: "/usuario-afiliado-redefinir-senha",
    name: "recoveryAffiliatePass",
    props: true,
    params: true,
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/people/RedefinePass"),
    meta: { title: "Recuperar senha", requiresAuth: true },
  },
];
